import React from 'react'

import { mq } from 'marketing-site/src/library/utils'
import { IProps } from './index'
import { Text } from 'marketing-site/src/library/elements/Text'
import { RichText } from 'marketing-site/src/mvp/library/elements/RichText'

export const InteractiveCard: React.FC<IProps> = ({
  eyebrow,
  title,
  subhead,
  cta,
  image,
  ctaUrl,
}) => {
  return (
    <div className="interactive-card">
      <a href={ctaUrl}>
        <div className="interactive-card__image">{image}</div>
      </a>
      <div className="interactive-card__content">
        {eyebrow && (
          <div className="interactive-card__eyebrow">
            <Text size="eyebrow">{eyebrow}</Text>
          </div>
        )}
        <div className="interactive-card__title">
          <Text size={subhead ? 'heading-5' : 'heading-4'}>{title}</Text>
        </div>
        {subhead && (
          <div className="interactive-card__subhead">
            <Text size="body">
              <RichText document={subhead} />
            </Text>
          </div>
        )}
        {cta && <div className="interactive-card__cta">{cta}</div>}
      </div>
      <style jsx>
        {`
          .interactive-card {
            height: 100%;
            display: flex;
            flex-direction: column;
            max-width: 25rem;

            &__image {
              border-radius: 1rem;
              overflow: hidden;
              transition: transform 250ms;

              // The following lines will keep the ImageWithModalVideo
              // with an aspect ratio of 3:2 no matter the image size.
              & :global(.image-with-modal-video) {
                width: 100%;
              }

              & :global(picture) {
                width: 100%;
                height: 0;
                padding-bottom: calc(100% / 3 * 2);
                position: relative;
              }

              & :global(picture img) {
                position: absolute;
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center;
              }
            }

            &__image:hover {
              transform: translateY(-4px);
              cursor: pointer;
            }

            &__title {
              margin-top: 0.75rem;
            }

            &__eyebrow {
              margin-top: 1.5rem;
            }

            &__subhead {
              margin-top: 0.75rem;
            }

            &__cta {
              display: block;
              margin-top: 1.5rem;
            }

            &__image {
              width: 100%;
              height: auto;
            }

            &__content {
              flex: 1;
              display: flex;
              flex-direction: column;
              text-align: left;
              padding-left: 0.5rem;
              padding-right: 0.5rem;
            }
          }

          @media (${mq.tablet}) {
            .interactive-card {
              &__eyebrow {
                margin-top: 2rem;
              }
              &__image {
                border-radius: 1.5rem;
              }
            }
          }
        `}
      </style>
    </div>
  )
}
